import React, { createContext, useState } from "react";

export const UnidadesContext = createContext();

const initialState = {
  unidades: [],
  numero_unidad: "",
  cedis: "",
  negocio: "",
  unidad_disponible: "",
};
const initialStateFormFormatoSalida = {
  destino: [],
  fecha_salida: "",
  hora_salida: "",
  marchamo: "",
  no_cajas: "",
  operador: "",
  cel_operador: "",
  tripulacion: [],
  cel_tripulacion: "",
  observaciones: "",
  tiendas: [],
};
export const UnidadesProvider = ({ children }) => {
  const [unidadesState, setUnidadesState] = useState(initialState);
  const [formFormatoSalida, setFormFormatoSalida] = useState(
    initialStateFormFormatoSalida
  );

  const setUnidadesDummy = () => {
    if (localStorage.getItem("unidades"))
      return setUnidadesState({
        ...unidadesState,
        unidades: [...JSON.parse(localStorage.getItem("unidades"))],
      });

    //   Añadimos nuestro camiones
    localStorage.setItem(
      "unidades",
      JSON.stringify([
        {
          unidad_id: 1,
          unidad_numero: "408-011FD7",
          cedis: "BC",
          negocio: "ELEKTRA",
          unidad_disponible: 1,
        },
        {
          unidad_id: 2,
          unidad_numero: "408-011FD8",
          cedis: "BCS",
          negocio: "ELEKTRA",
          unidad_disponible: 1,
        },
        {
          unidad_id: 3,
          unidad_numero: "408-011FD9",
          cedis: "Sinaloa",
          negocio: "ELEKTRA",
          unidad_disponible: 1,
        },
        {
          unidad_id: 4,
          unidad_numero: "408-011FD10",
          cedis: "Tamaulipas",
          negocio: "ELEKTRA",
          unidad_disponible: 1,
        },
        {
          unidad_id: 5,
          unidad_numero: "408-011FD11",
          cedis: "Tlahuac",
          negocio: "NETO",
          unidad_disponible: 1,
        },
        {
          unidad_id: 6,
          unidad_numero: "408-011FD12",
          cedis: "Iztacalco",
          negocio: "NETO",
          unidad_disponible: 1,
        },
        {
          unidad_id: 7,
          unidad_numero: "408-011FD13",
          cedis: "Tlahuac",
          negocio: "NETO",
          unidad_disponible: 1,
        },
        {
          unidad_id: 8,
          unidad_numero: "408-011FD14",
          cedis: "Tlahuac",
          negocio: "NETO",
          unidad_disponible: 1,
        },
        {
          unidad_id: 9,
          unidad_numero: "408-011FD15",
          cedis: "Tlahuac",
          negocio: "NETO",
          unidad_disponible: 1,
        },
        {
          unidad_id: 10,
          unidad_numero: "408-011FD16",
          cedis: "Tlahuac",
          negocio: "NETO",
          unidad_disponible: 1,
        },
        {
          unidad_id: 11,
          unidad_numero: "408-011FD17",
          cedis: "Tlahuac",
          negocio: "NETO",
          unidad_disponible: 1,
        },
        {
          unidad_id: 12,
          unidad_numero: "408-011FD18",
          cedis: "Tlahuac",
          negocio: "NETO",
          unidad_disponible: 1,
        },
        {
          unidad_id: 13,
          unidad_numero: "408-011FD19",
          cedis: "Tlahuac",
          negocio: "NETO",
          unidad_disponible: 1,
        },
        {
          unidad_id: 14,
          unidad_numero: "408-011FD20",
          cedis: "Tlahuac",
          negocio: "NETO",
          unidad_disponible: 1,
        },
      ])
    );
    return setUnidadesState({
      ...unidadesState,
      unidades: [...JSON.parse(localStorage.getItem("unidades"))],
    });
  };
  const handleChange = (target) => {
    setUnidadesState({ ...unidadesState, [target.name]: target.value });
  };
  const clearUnidadesState = () => {
    setUnidadesState(initialState);
  };
  const guardarUnaUnidadEnLaLista = (unidad_numero, status) => {
    if (localStorage.getItem("unidades")) {
      let unidades = JSON.parse(localStorage.getItem("unidades"));
      let index = unidades.findIndex((x) => x.unidad_numero === unidad_numero);

      if (index >= 0) {
        unidades[index].unidad_disponible = status;

        localStorage.setItem("unidades", JSON.stringify(unidades));
        alert("Ha sido guardado todo con éxito");
        return true;
      } else {
        alert(
          "No se pudo encontrar la unidad, no pudo se procesada la solicitud"
        );
        return false;
      }
    } else {
      alert(
        "No se encontraron unidades en la lista, no pudo se procesada la solicitud"
      );
      return false;
    }
  };
  const setUnidades = (aUnidades) => {
    setUnidadesState({ ...unidadesState, unidades: aUnidades });
  };
  /**
   * Limpia el estado del formulario
   */
  const clearStateFormFormatoSalida = () => {
    setFormFormatoSalida({
      ...initialStateFormFormatoSalida,
      tiendas: [...[]],
    });
  };

  const eligeTienda = ({ target }) => {
    agregarTienda(target.value);
  };
  /**
   * Agrega una tienda
   * @param {string} tiendaAgregar
   */
  const agregarTienda = (sTienda) => {
    if (sTienda !== "" && !formFormatoSalida.tiendas.includes(sTienda)) {
      let aux = formFormatoSalida.tiendas;
      aux.push(sTienda);
      setFormFormatoSalida({
        ...formFormatoSalida,
        tiendas: aux,
      });
    }
  };
  /**
   * Quitar todas las tiendas seleccionadas
   */
  const quitarTiendas = () => {
    // setTiendas([...[]]);
    setFormFormatoSalida({
      ...formFormatoSalida,
      tiendas: [],
    });
  };
  /**
   * Quitar tiendas seleccionadas
   * @param {number} index
   */
  const quitarTienda = (index) => {
    let tiendasAux = formFormatoSalida.tiendas;
    tiendasAux.splice(index, 1);
    setFormFormatoSalida({
      ...formFormatoSalida,
      tiendas: tiendasAux,
    });
  };
  return (
    <UnidadesContext.Provider
      value={{
        unidadesState,
        setUnidadesState,
        setUnidadesDummy,
        handleChange,
        clearUnidadesState,
        guardarUnaUnidadEnLaLista,
        setUnidades,
        formFormatoSalida,
        setFormFormatoSalida,
        clearStateFormFormatoSalida,
        eligeTienda,
        quitarTiendas,
        quitarTienda,
      }}
    >
      {children}
    </UnidadesContext.Provider>
  );
};
